// Охрана маршрутов (прежний middleware/auth.global.ts): вход, временный пароль, выключенная приёмка.
import type { Router } from 'vue-router';
import type { SessionView } from '@/shared/contracts';
import { api, ApiError } from '@/runtime/http';
import { deferError } from '@/runtime/errors';

const OPEN = new Set(['/login', '/login/telegram', '/tg', '/newpassword']);

export function installGuard(router: Router): void {
  router.beforeEach(async (to, from) => {
    if (OPEN.has(to.path)) return true;
    // Смена только query (поиск, фильтры, ?person=) не меняет требования к сессии:
    // без этого каждая навигация ждала /api/session и отменяла предыдущую.
    if (to.path === from.path && from.matched.length > 0) return true;
    try {
      const session = await api<SessionView>('/api/session');
      if (session.mustChangePassword && to.path !== '/profile' && to.path !== '/profile/edit') return '/profile';
      if ((to.path === '/review' || to.path.startsWith('/review/')) && !session.reviewEnabled) {
        deferError({ statusCode: 404, message: 'Раздел приёмки отключён' });
      }
      return true;
    } catch (error) {
      const code = error instanceof ApiError ? error.statusCode : 0;
      if (code === 401 || code === 403 || code === 503) {
        return to.path === '/checkin' ? { path: '/login', query: { checkinEvent: String(to.query.event ?? ''), checkinCode: String(to.query.code ?? '') } } : '/login';
      }
      deferError({ statusCode: 503, message: 'Портал временно недоступен. Попробуйте открыть его снова.' });
      return true;
    }
  });
}
